import {
    METHOD_GET,
    METHOD_POST,
    METHOD_PUT,
    METHOD_DELETE,
    SERVER_URL,
} from '../constants/api';
import { headersAuthSendReceiveJson } from '../headers';
import { apiHandleResponse } from '../../util/api';
import {http} from './common'
import { getEndDate, getStartDate } from '../../util/date';

export type SearchCriteriaFilter = {
    field: string;
    equator?: "equals" | "greater_than_or_equals_to" | "less_than_or_equals_to";
    value?: boolean | string;
    customFilter: boolean;
    type?: "DATE" | "SIGNIFICANCE";
    relativeFilter?: string;
    dates?: {
      equator: "greater_than_or_equals_to" | "less_than_or_equals_to";
      value: string;
    }[];
};

export interface SearchCriteria {
    criteria: string; // JSON string for SearchCriteriaFilter[]
    id: number;
    userId: number;
    name: string;
    criteriaName: string;
    isDefault: boolean;
    isPublic: boolean;
    searchCriteriaTypeId: number;
    searchCriteriaType: {
        id: number;
        name: string;
        description: string | null;
        searchCriteria: any[];
    };
    models: any[];
}

async function getCriteriaByPageName(pageName: { name: string; }) : Promise<SearchCriteria[]> {
    const response = await fetch(`${SERVER_URL}/api/v1/cms/searchcriteria/list`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
        // body: JSON.stringify(pageName),
    });

    return apiHandleResponse(response);
}

export async function fetchSearchCriteriaForPage( name: string = 'claimAnalysis-landing', userSession ) {
    const data = await getCriteriaByPageName({ name });

    const parsedData = data
        .filter( x => x.name === name )
        .map( x => {
            const parsed = JSON.parse( x.criteria || '[]' ),
                filter = parsed.filter( x => !x.customFilter ),
                customFilter = parsed.filter( x => x.customFilter );

            let modifiedCustomFilters = customFilter.filter(item => item.type !== 'DATE' && item.type !== 'SIGNIFICANCE');

            const dateObj = customFilter.find(item => item.type === 'DATE')
            
            if (dateObj) {
                if (dateObj.relativeFilter === 'custom') {
                    modifiedCustomFilters = [...modifiedCustomFilters, ...dateObj.dates.map(item => ({ ...item, field: dateObj.field, relativeFilter: dateObj.relativeFilter }))]
                } else {
                    const startdate = getStartDate(dateObj.relativeFilter);
                    const enddate = getEndDate(dateObj.relativeFilter);
    
                    modifiedCustomFilters = [
                        ...modifiedCustomFilters,
                        {
                            field: dateObj.field,
                            equator: 'greater_than_or_equals_to',
                            value: startdate,
                            relativeFilter: dateObj.relativeFilter
                        },
                        {
                            field: dateObj.field,
                            equator: 'less_than_or_equals_to',
                            value: enddate,
                            relativeFilter: dateObj.relativeFilter
                        }
                    ];
                }
            }

            const significance = Boolean( customFilter.find(item => item.type === 'SIGNIFICANCE')?.value );

            return ({
                ...x,
                filters: {
                    filter,
                    customFilter: modifiedCustomFilters,
                    significance
                }
            })
        });

        const sortedFilters= sortByUserId(parsedData, userSession)
        const defaultValue = sortedFilters.find(x => x.isDefault && x.name === name);

        return [ sortedFilters, defaultValue ];
}

function sortByUserId(arr, userId) {
    return arr.sort((a, b) => {
        if (a.userId === userId && b.userId !== userId) return -1;
        if (a.userId !== userId && b.userId === userId) return 1;
        return 0; // Leave the order unchanged for other items
    });
 }

async function createSearchCriteria(searchCriteria) {
    const response = await fetch(`${SERVER_URL}/api/v1/cms/searchcriteria`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(searchCriteria)
    });
    return apiHandleResponse(response);
}

const getSearchCriteriaDependentsList = async (id) =>
    http.get(`/api/v1/cms/searchcriteria/dependencies/${id}`);


async function getSearchCriteriaList() {
    const response = await fetch(`${SERVER_URL}/api/v1/cms/searchcriteria/list`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    });
    return apiHandleResponse(response);
}

async function deleteSearchCriteriaList(id) {
    const response = await fetch(`${SERVER_URL}/api/v1/cms/searchcriteria/${id}`, {
        method: METHOD_DELETE,
        headers: headersAuthSendReceiveJson(),
    });
    return apiHandleResponse(response);
}

async function upateSearchCriteria(searchCriteria) {
    const response = await fetch(`${SERVER_URL}/api/v1/cms/searchcriteria`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(searchCriteria)
    });
    return apiHandleResponse(response);
}

async function getSearchCriteriaTypes() {
    const response = await fetch(`${SERVER_URL}/api/v1/cms/searchcriteria/types`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    });
    return apiHandleResponse(response);
}

export {
    getCriteriaByPageName,
    createSearchCriteria,
    getSearchCriteriaList,
    deleteSearchCriteriaList,
    upateSearchCriteria,
    getSearchCriteriaTypes,
    getSearchCriteriaDependentsList
};